import {BusinessCaseGeneratorPageStateController} from "./BusinessCaseGeneratorPageStateController";
import {BusinessCaseGeneratorPageFilterController} from "./BusinessCaseGeneratorPageFilterController";
import {BusinessCaseGeneratorPageStatisticsController} from "./BusinessCaseGeneratorPageStatisticsController";
import type {MithraMaterializedApi} from "../../../services/MithraMaterializedApi";
import type AuthStore from "../../../authentication/AuthStore";
import type ProfileStore from "../../../stores/ProfileStore";
import {makeAutoObservable} from "mobx";
import {BusinessCaseGeneratorPageDataController} from "./BusinessCaseGeneratorPageDataController";

export type Page = 'review-opportunities'
    | 'risk-assessment'
    | 'success-factors'


export class BusinessCaseGeneratorPageController {
    readonly pageStateController: BusinessCaseGeneratorPageStateController;
    readonly pageDataController: BusinessCaseGeneratorPageDataController;
    readonly pageFilterController: BusinessCaseGeneratorPageFilterController
    readonly pageStatisticsController: BusinessCaseGeneratorPageStatisticsController;

    constructor(
        private api: MithraMaterializedApi,
        private auth: AuthStore,
        private profile: ProfileStore,
    ) {
        makeAutoObservable(this)
        this.pageStateController = new BusinessCaseGeneratorPageStateController(this, this.profile, this.auth);
        this.pageDataController = new BusinessCaseGeneratorPageDataController(this, this.pageStateController, this.api, this.auth, this.profile);
        this.pageFilterController = new BusinessCaseGeneratorPageFilterController(this, this.profile)
        this.pageStatisticsController = new BusinessCaseGeneratorPageStatisticsController(this.profile, this.api);
    }

    navigateToPage(page: Page) {
        this.pageStateController.setPage(page);
    }
}
